import { Loader } from "@mantine/core";
import { useTranslation } from "react-i18next";

import classes from "./StartBreakButton.module.css";
import useStartBreak from "./useStartBreak";

const StartBreakButton = () => {
  const { t } = useTranslation();
  const { startBreak, startingBreak } = useStartBreak();

  return (
    <button
      className={classes.startBreakButton}
      disabled={startingBreak}
      onClick={startBreak}
      type={"button"}
    >
      {startingBreak && <Loader color={"var(--mantine-color-white)"} size={12} />}
      <span className={classes.startBreakLabel}>{t("agentStatus.startBreak")}</span>
    </button>
  );
};

export default StartBreakButton;
